/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];


export const AccountStatus = {
  Active: 'Active',
  Blocked: 'Blocked',
} as const;
